module.exports = __webpack_public_path__ + "static/dagny-regular-e531ad0c955d3e5c79747ee75186bafe.woff2";